const baseURL = "https://intranet.aznext.it:8443/api/POL";

const DocInformativi = [
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/ckfinder/userfiles/files/documenti/STAMPA%20PRIVACY.pdf">
    INFORMATIVA PRIVACY (GDPR)
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/ckfinder/userfiles/files/Trasparenza/GDPR/Informativa_FEA_con_OTP.pdf">
    INFORMATIVA FIRMA ELETTRONICA AVANZATA (FEA) CON OTP
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/ALTRINFDIS.pdf">
    INFORMATIVA SUI CONTRATTI E SERVIZI A DISTANZA
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/ckfinder/userfiles/files/documenti/Informativa_SIC_Crif_(vuoto).pdf">
    INFORMATIVA SIC
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FICCONLINE.pdf">
    FOGLIO INFORMATIVO CONTO "IO SONO ONLINE"
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FIDONLINE.pdf">
    DOCUMENTO INFORMATIVO SULLE SPESE (FID) CONTO "IO SONO ONLINE"
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FICCTDONLI.pdf">
    FOGLIO INFORMATIVO TIME DEPOSIT "CONTO DEPOSITO ONLINE"
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FIHBHOME.pdf">
    FOGLIO INFORMATIVO INTERNET BANKING AZ@HOME
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FICDENEIND.pdf">
    FOGLIO INFORMATIVO CARTA NEXI DEBIT INDIVIDUALE
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/GUIDACC.pdf">
    GUIDA - IL CONTO CORRENTE
  </a>,
  <a style={{ color: "#0049EA", fontFamily: "Poppins-Regular" }} target="_blank" href="https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/ALTRABF.pdf">
    GUIDA PRATICA ABF - RISOLUZIONE STRAGIUDIZIALE CONTROVERSIE
  </a>,
];

const Colors = {
  w: "#fff",
  b: "#000",

  b1: "#0049EA",
  b2: "#0A69E8",
  b3: "#2574F2",
  b4: "#0061DF",
  b5: "#003897",
  b6: "#023AAE",
  darkBlue: "#3A4F66",
};

const fonts = {
  b: "Poppins-Bold",
  m: "Poppins-Medium",
  r: "Poppins-Regular",
  s: "Poppins-SemiBold",
  l: "Poppins-Light",
};

const bp = { xs: 480, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1600 };

export { baseURL, DocInformativi, Colors, fonts, bp };
